<template>
  <div>
    <div class="home">
      <van-nav-bar title="合作伙伴" left-text="返回" @click-left="onClickLeft" fixed/>
      <div class="navheight"></div>
      <div class="content">
        <div class="nongmu_cont">
          <div class="contentTie">
            <img src="../../assets/joinusimg/companylogo/huayang@3x.png" alt="">
            <div class="company">河南华扬农牧有限公司</div>
          </div>
          <div class="labInfo">
            <span>生猪</span>
            <span>育种</span>
            <span>养殖</span>
            <span>销售</span>
          </div>
          <div class="companyInfo">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/huachang/3.jpg" alt="">
            <div class="companyWord">河南华扬农牧有限公司位于河南省汝州市，是集专业育种、商品猪饲养、优质生物饲料生产和销售为一体的集约化规模养殖企业，是国内首家中丹合资生猪标准化示范基地。公司主要产品为祖代丹系大白猪、长白猪、杜洛克种猪、二元母猪和生物饲料。公司丹系生猪产品具有产仔率高、生长速度快、饲料转化率高、瘦肉多、肉质好、抗病能力强等特点。公司养猪基地内，猪舍及完善的配套设施严格按照丹麦养猪产业模式，实现全封闭、智能化、信息化，并利用丹育育种平台，实现与丹麦育种中心同步育种，达到真正与国际接轨。</div>
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/huachang/1.jpg" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/huachang/2.jpg" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/huachang/4.jpg" alt="">
          </div>
        </div>
      </div>
      <div class='bottom'>
        <div class="title">经营范围</div>
          <div class="info"> 专业育种、商品猪饲养、优质生物饲料生产和销售</div>
      </div>
      <footer class="nongmu-footer">
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/wangzhi@3x.png" alt=""></dt>
          <dd><a href="http://www.hnhynm.com/">http://www.hnhynm.com/</a></dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt>
          <dd>汝州市广成西路71号</dd>
        </dl>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partner',
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/style/partner.scss';
</style>
